import { Quote, MapPin } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { assetUrl } from "@/lib/api";

function Avatar({ t, i }) {
  if (t.avatarUrl) {
    return (
      <img
        src={assetUrl(t.avatarUrl)}
        alt={t.name}
        loading="lazy"
        className="h-12 w-12 rounded-full border-2 border-white object-cover shadow-sm"
        data-testid={`testimonial-avatar-${i}`}
      />
    );
  }
  const initials = (t.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase();
  return (
    <span
      className="flex h-12 w-12 items-center justify-center rounded-full border-2 border-white bg-gradient-to-br from-[#1B3A5C] to-[#0E8A8A] font-syne text-sm font-bold text-white shadow-sm"
      data-testid={`testimonial-avatar-${i}`}
    >
      {initials}
    </span>
  );
}

export default function Testimonials({ items }) {
  return (
    <section className="bg-white py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionHead
          index="05"
          label="Success Stories"
          title="Trusted at the last mile."
          description="Kirana owners, banking correspondents and fintech founders — real partners, real earnings."
          testId="testimonials-head"
        />
        <div className="grid gap-6 md:grid-cols-3">
          {(items || []).map((t, i) => (
            <Reveal key={i} delay={i * 0.1} className="h-full">
              <figure
                className="flex h-full flex-col rounded-2xl border border-[#E2DDD5] bg-[#FAF9F5] p-7 shadow-sm transition-all duration-300 hover:border-[#0E8A8A]/40 hover:bg-white hover:shadow-md"
                data-testid={`testimonial-${i}`}
              >
                <Quote size={22} className="mb-5 text-[#B8860B]/70" />
                <blockquote className="flex-1 text-sm leading-relaxed text-[#45536A] sm:text-base">“{t.quote}”</blockquote>
                <figcaption className="mt-6 flex items-center gap-4 border-t border-[#E2DDD5] pt-5">
                  <Avatar t={t} i={i} />
                  <div>
                    <p className="font-syne font-semibold text-[#0F1B2B]">{t.name}</p>
                    <p className="mt-0.5 flex items-center gap-1.5 text-xs text-[#8896AB]">
                      {t.role} <MapPin size={11} className="text-[#B8860B]/70" /> {t.location}
                    </p>
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
